/* holay: "Buy on Amazon" 버튼 (사용자 2026-11-04 "구매하기 누르면 아마존으로")
   - 옵션을 바꾸면(테마 표준 이벤트 productSelect) 버튼 링크를 그 옵션의 ASIN(= Variant SKU)으로 바꿈
   - 광고 링크에 ?amz=<Attribution 태그 쿼리> 가 붙어 오면 그 방문 동안 그 태그를 씀 (채널별 성과 비교)
   - 클릭하면 Shopify 고객 이벤트 holay_amazon_click 을 보냄 -> 맞춤 픽셀에서 Meta/Google 전환으로 전달 */
const KEY = 'holay_amz_tag';
try {
  const q = new URLSearchParams(location.search).get('amz');
  if (q) sessionStorage.setItem(KEY, q.replace(/^\?/, ''));
} catch (e) {}

class HolayAmazonBuy extends HTMLElement {
  connectedCallback() {
    this.target = this.closest('[id*="ProductInformation-"], featured-product-information, [id*="QuickAdd-"]');
    this.addEventListener('click', this.#onClick, true);
    holayEvents.then((ev) => {
      if (ev && this.target) this.target.addEventListener(ev.StandardEvents.productSelect, this.#onSelect);
    });
    this.update(new URLSearchParams(location.search).get('variant'));
  }

  disconnectedCallback() {
    holayEvents.then((ev) => {
      if (ev && this.target) this.target.removeEventListener(ev.StandardEvents.productSelect, this.#onSelect);
    });
  }

  get map() {
    if (!this._map) {
      try { this._map = JSON.parse(this.querySelector('[data-holay-variants]').textContent); } catch (e) { this._map = {}; }
    }
    return this._map;
  }

  get tag() {
    let t = '';
    try { t = sessionStorage.getItem(KEY) || ''; } catch (e) {}
    return t || this.dataset.tag || '';
  }

  update(id) {
    const a = this.querySelector('a.holay-amazon__btn');
    if (!a) return;
    const vid = id && this.map[id] ? String(id) : a.dataset.variantId;
    const asin = this.map[vid] || a.dataset.asin;
    if (!asin) return;
    a.href = 'https://www.amazon.com/dp/' + asin + (this.tag ? '?' + this.tag : '');
    a.dataset.asin = asin;
    a.dataset.variantId = vid;
  }

  #onSelect = (event) => {
    (event.promise || Promise.resolve(event))
      .then((r) => {
        const res = r && r.detail && r.detail.resource;
        if (res && res.id) this.update(String(res.id));
      })
      .catch(() => {});
  };

  #onClick = (event) => {
    const a = event.target.closest && event.target.closest('a.holay-amazon__btn');
    if (!a) return;
    this.update(new URLSearchParams(location.search).get('variant'));   /* 누르는 순간의 옵션으로 한 번 더 */
    try {
      window.Shopify?.analytics?.publish?.('holay_amazon_click', {
        asin: a.dataset.asin,
        variant_id: a.dataset.variantId,
        product_title: this.dataset.productTitle,
        page: location.pathname,
        tag: this.tag
      });
    } catch (e) {}
  };
}

const holayEvents = import('@shopify/events').catch(() => null);
if (!customElements.get('holay-amazon-buy')) customElements.define('holay-amazon-buy', HolayAmazonBuy);
